import { createApi } from '@reduxjs/toolkit/query/react'
import { MANAGE_STATUS_ADD, MANAGE_STATUS_DELETE, MANAGE_STATUS_DETAILS, MANAGE_STATUS_EDIT, MANAGE_STATUS_LIST } from "config/apiPaths"
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const manageStatusApi = createApi({
    reducerPath: 'ManageStatusApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/status",
    }),
    tagTypes: ["ManageStatusApi", "ManageStatusDetails"],
    endpoints: (builder) => ({

        // manage status list
        manageStatusList: builder.query({
            query: ({ search = "", status = "", page = 1, limit = 10, module = "", client_type = "", sort = { column: "id", direction: "ASC" } }) => ({
                method: "PATCH",
                url: MANAGE_STATUS_LIST,
                data: { search, status, page, limit, module, client_type, sort }
            }),

            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["ManageStatusApi"]
        }),

        // delete status
        deleteStatus: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `${MANAGE_STATUS_DELETE}/${id}`
            }),
            invalidatesTags: ["ManageStatusApi", "ManageStatusDetails"]
        }),

        // create status
        addStatus: builder.mutation({
            query: (data) => ({
                method: "POST",
                url: MANAGE_STATUS_ADD,
                data
            }),
            invalidatesTags: ["ManageStatusApi"]
        }),

        // Status details
        statusDetails: builder.query({
            query: (id) => ({
                method: "GET",
                url: `${MANAGE_STATUS_DETAILS}/${id}`
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["ManageStatusDetails"]
        }),

        // update status
        updateStatus: builder.mutation({
            query: ({ data, statusId }) => ({
                method: "PUT",
                url: `${MANAGE_STATUS_EDIT}/${statusId}`,
                data
            }),
            invalidatesTags: ["ManageStatusApi", "ManageStatusDetails"]
        })
    })
})

export const {
    useManageStatusListQuery,
    useDeleteStatusMutation,
    useAddStatusMutation,
    useStatusDetailsQuery,
    useUpdateStatusMutation

} = manageStatusApi;